import { render, staticRenderFns } from "./PhotoDash.vue?vue&type=template&id=0787c32a&"
import script from "./PhotoDash.vue?vue&type=script&lang=js&"
export * from "./PhotoDash.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/components/beer-dash.less?vue&type=style&index=0&lang=less&"
import style1 from "@/assets/styles/components/slick.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports